/**
 * Analytics Event Constants
 * Centralized event names for Mixpanel tracking.
 * Use these constants to avoid string typos and maintain consistency.
 *
 * Usage:
 *   import { ANALYTICS_EVENTS } from '@/lib/analytics/constants';
 *   analytics.track(ANALYTICS_EVENTS.SIGNUP_SUCCESS, { email: '...' });
 */

export const ANALYTICS_EVENTS = {
  // Authentication Events
  SIGNUP_SUCCESS: "User Signed Up",
  LOGIN_SUCCESS: "User Login",
  EMAIL_VERIFIED: "Email Verified",
  LOGOUT: "User Logout",
  PASSWORD_RESET: "Password Reset",

  // Settings Events
  PASSWORD_CHANGED: "Password Changed",
  NOTIFICATION_SETTINGS_CHANGED: "Notification Settings Changed",
  ACCOUNT_DELETED: "Account Deleted",
  PHONE_NUMBER_ADDED: "Phone Number Added",
  EMAIL_CHANGED: "Email Changed",

  // Profile Events
  PROFILE_CREATED: "Profile Created",
  PROFILE_UPDATED: "Profile Updated",
} as const

// =============================================================================
// ANALYTICS PROPERTY CONSTANTS
// =============================================================================

export const ANALYTICS_PROPERTIES = {
  EMAIL: "email",
  SOURCE: "source",
  METHOD: "method",
  NOTIFICATION_TYPES: "notification_types",
  PHONE: "phone",
  NEW_EMAIL: "new_email",
  FIELDS_UPDATED: "fields_updated",
} as const

// =============================================================================
// TYPE EXPORTS
// =============================================================================

export type AnalyticsEventName = (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS]
export type AnalyticsPropertyName = (typeof ANALYTICS_PROPERTIES)[keyof typeof ANALYTICS_PROPERTIES]
